<template lang="pug">
  v-flex.loans.mt-xs-5.mt-md-0(xs12 lg12)
    //-- START_WINDOW
    v-stepper#main-stepper(alt-labels v-model="onboarding" v-if="!finishedTransact")
      v-layout(row wrap justify-center)
        v-flex(xs10 sm7 md4 lg3)
          v-stepper-header
            v-stepper-step(step="1" :complete="onboarding >= 1")
            v-divider
            v-stepper-step(step="2" :complete="onboarding >= 2")
            v-divider
            v-stepper-step(step="3" :complete="onboarding >= 3")
      v-flex(xs12 sm12 md4 lg4)
      v-stepper-items
        v-stepper-content(step="1")
          loans-first-step(:uniqueTrackId="uniqueTrackId")
        v-stepper-content(step="2")
          loans-second-step(v-if="possibilityInfo" :uniqueTrackId="uniqueTrackId" :possibilityInfo="possibilityInfo")
        v-stepper-content(step="3")
          loans-thrid-step(v-if="cronograma" :uniqueTrackId="uniqueTrackId" :cronograma="cronograma" :data="additionalData")
    //-- END_WINDOW
    loans-finished(v-else)
    //-- LOANS WELCOME MODAL
    v-dialog(v-model="dialogLoans" :persistent="true")
      v-card#info-loans
        v-card-title
          v-flex
            h1.omnesSemibold.text-xs-center ¿Cómo funciona?
        v-card-text
          v-layout(wrap)
            v-flex(xs12 md4)
              v-layout(wrap)
                v-flex.text-xs-center(xs4 offset-sm1 sm3 md12)
                  img.mt-2(:src='loans.bullet1')
                v-flex(xs8 sm7 md12)
                  h3.omnesRegular.info--text.mb-2.mt-2.text-xs-left.text-md-center Solicítanos el monto de dinero que necesitas y el número de cuotas que más se adecúe a tus necesidades.
            v-flex(xs12 md4)
              v-layout(wrap)
                v-flex.text-xs-center(xs4 offset-sm1 sm3 md12)
                  img.mt-2(:src='loans.bullet2')
                v-flex(xs8 sm7 md12)
                  h3.omnesRegular.info--text.mb-2.mt-2.text-xs-left.text-md-center Confirma el resumen de tu solicitud y las nuevas condiciones de tu póliza.
            v-flex(xs12 md4)
              v-layout(wrap)
                v-flex.text-xs-center(xs4 offset-sm1 sm3 md12)
                  img.mt-2(:src='loans.bullet3')
                v-flex(xs8 sm7 md12)
                  h3.omnesRegular.info--text.mb-2.mt-2.text-xs-left.text-md-center Realizamos el desembolso en menos de 72 horas hábiles al mismo número de cuenta en la cual recibes tu ingreso.
          v-layout(wrap)
            v-flex(xs12 md4 lg4)
            v-flex(xs12 md4 lg4)
              p.yt-video
                img(:src="playicon" alt="playicon")
                a(href="#" @click="showYTVideo($event)") VER VIDEO TUTORIAL
            v-flex(xs12 md4 lg4)
          br(v-if="$vuetify.breakpoint.mdAndUp")
          v-card-actions
            v-layout
              v-flex.text-xs-center
                v-btn(color="dark" @click="acceptTerms()") ¡Estoy listo!
            v-layout(wrap)
              v-flex(xs12 md12 style="text-align:center")
                p
                  | Al continuar,&nbsp;
                  a(:href="termsAndPolicy" target="_blank") acepto el envío de comunicaciones vía correo electrónico, modificación de los términos de mi póliza y las condiciones de uso del préstamo
    //- YT Dialog
    v-dialog.youtube-video(v-model="dialogYT" width="800" :persistent="true")
      v-card
        v-card-text(style="position:relative")
          v-btn.youtube-close-btn(icon @click="closeYTDialog()" outlined) x
          v-layout(wrap)
            v-flex(xs12 sm12 md12 lg12)
              youtube(video-id="mIUHhnwo2c4" width="100%" height="450" ref="youtube" @ended="onEndYT")
</template>

<script>
import LoansFirstStep from './LoansFirstStep'
import LoansSecondStep from './LoansSecondStep'
import LoansThridStep from './LoansThridStep'
import LoansFinished from './LoansFinished'
import { mapActions, mapGetters } from 'vuex'
import Functionalities from '../../interfaces/functionalities'

export default {
  data () {
    return {
      uniqueTrackId: null,
      minAmount: 0,
      maxAmount: 0,
      dialogLoans: false,
      dialogYT: false,
      additionalData: null,
      cronograma: null,
      onboarding: 1,
      length: 3,
      finishedTransact: false,
      possibilityInfo: null,
      maxAmountLoan: '',
      termsAndPolicy: require('./../../assets/loans/endoso_prestamos.pdf'),
      playicon: require('./../../assets/icons/icon-playvideo.png'),
      loans: {
        bullet1: require('./../../assets/loans/bullet-1.svg'),
        bullet2: require('./../../assets/loans/bullet-2.svg'),
        bullet3: require('./../../assets/loans/bullet-3.svg')
      },
      amplitude: {
        events: {
          videoViewed: 'Video Tutorial Visto'
        }
      }
    }
  },
  methods: {
    ...mapActions('user', ['setTrackingClient', 'sendRemarketing']),
    acceptTerms () {
      // [SEND TRACKING]
      let hashT = [{
        categoria: 'Prestamos RPP-IFP',
        trackingId: this.uniqueTrackId,
        screen: 'terminos_condiciones',
        document: this.basicInfo.numeroDocumento,
        name: this.basicInfo.nombres,
        email: this.basicInfo.correo,
        phone: this.basicInfo.celular,
        data: '',
        errorType: '',
        errorData: '',
        date: Date.now()
      }]
      this.setTrackingClient(hashT)
      // [SEND TRACKING]
      this.dialogLoans = false
      
      this.$gtm.trackEvent({
        "event":"select_button",
        "Nombre Sección":"Zona Segura",
        "TipoElemento":"Botón",
        "TipoAccion":"Préstamo - cómo funciona - continuar",
        "CTA":"Estoy listo"
      })
    },
    showYTVideo (evt) {
      evt.preventDefault()
      this.dialogYT = true
    },
    onEndYT () {
      // TRACK EVENT - AMPLITUDE
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.videoViewed,
          {
            'Nombre de video tutorial': 'Prestamos RPP-IFP',
            'Producto consultado': 'Rentas',
            '% Porcentaje de video visto': 100
          }
        )
    },
    async closeYTDialog () {
      // TRACK EVENT - AMPLITUDE
      let player = this.$refs.youtube.player
      player.pauseVideo()
      let p = await player.getCurrentTime()
      let d = await player.getDuration()
      let c = parseFloat(((p / d) * 100).toFixed(2))

      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.videoViewed,
          {
            'Nombre de video tutorial': 'Prestamos RPP-IFP',
            'Producto consultado': 'Rentas',
            '% Porcentaje de video visto': c
          }
        )
      this.dialogYT = false
    },
    leaving () {
      const env = process.env.ENVIRONMENT
      let template = ''
      let sendRemarketing = false
      let monto = ''
      let numeroCuotas = ''
      let valorCuota = ''
      let tasaInteres = ''
      let asunto1 = ''
      if (this.dialogLoans && this.onboarding === 1) {
        template = 'efectivoalinstante.html'
        asunto1 = '¿' + this.names + ', necesitas efectivo? ¡Tienes un préstamo aprobado por ser cliente de Renta Particular Plus!'
        sendRemarketing = true
      } else if (!this.dialogLoans && this.onboarding === 1) {
        template = 'prestamosdolares.html'
        asunto1 = this.names + ', ¿Vas a dejar pasar esta oportunidad? Tienes un préstamo aprobado con una tasa exclusiva'
        sendRemarketing = true
      } else if (this.onboarding === 2) {
        template = 'oportunidadunica.html'
        monto = this.possibilityInfo.amount
        numeroCuotas = (this.possibilityInfo.cuotaSeleccionada - this.possibilityInfo.periodoGraciaExtraDiferido) < 2 ? 1 : this.possibilityInfo.cuotaSeleccionada - this.possibilityInfo.periodoGraciaExtraDiferido
        valorCuota = this.possibilityInfo.currency + ' ' + this.possibilityInfo.cuota.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        tasaInteres = (this.possibilityInfo.tasaPrestamo * 100).toFixed(2) + '%'
        asunto1 = this.names + ', ¡Falta Poco! ¡Estás a solo un paso de tener los ' + monto + ' que necesitas!'
        sendRemarketing = true
      } else if (this.onboarding === 3) {
        template = 'percance.html'
        asunto1 = this.names + ', ¿Necesitas ayuda para solicitar tu préstamo? ¡Comunícate con nosotros!'
        sendRemarketing = true
      } else {
        sendRemarketing = false
      }
      if (this.basicInfo.numeroDocumento != null) {
        if (sendRemarketing) {
          let request = {
            codigoRemarketing: '',
            producto: '4',
            identificador: this.basicInfo.numeroDocumento,
            detalle: {
              correo: '',
              codigoVenta: 'VTA-PRESTAMO',
              pantalla: 1,
              enviarCorreo: 0,
              datosCorreo: {
                url: '',
                plantilla: {
                  '1': template
                },
                utm: {}
              },
              datosProducto: {
                nombre: this.names,
                monto: monto,
                numeroCuotas: numeroCuotas,
                valorCuota: valorCuota,
                tasaInteres: tasaInteres,
                prestamoMaximo: this.maxAmountLoan,
                asunto1: asunto1
              },
              datosTitular: {
                numeroDocumento: '',
                nombre: this.names,
                apellidoPaterno: '',
                apellidoMaterno: '',
                telefono: '',
                originDocumentNumber: null,
                origenDatos: 1
              },
              datosPago: {
                idFrecuencia: '',
                fechaInicioSeguro: ''
              },
              remitente: {
                correoRemitente: 'prestamos@interseguro.com.pe',
                correoRemitenteDisplay: 'Interseguro Préstamos'
              }
            }
          }
          if (env === 'prod') {
            request.detalle.correo = this.basicInfo.correo
            request.detalle.datosCorreo.url = 'https://www.interseguro.pe/zona-segura'
          } else {
            request.detalle.correo = 'pruebasusuario.interseguro@gmail.com'
            request.detalle.datosCorreo.url = 'https://test.interseguro.pe/zona-segura'
          }
          this.sendRemarketing(request)
          return 'Está seguro de abandonar el proceso de préstamo?'
        }
      } else {
        return 'Está seguro de abandonar el proceso de préstamo?'
      }
    }
  },
  created () {
    let self = this
    window.onbeforeunload = self.leaving
    this.$root.$on('nextStep', function (loan) {
      var cloneLoanObject = {}
      Object.assign(cloneLoanObject, loan)
      self.onboarding = cloneLoanObject.step
      self.$store.commit('loans/setOnboarding', self.onboarding)
      // NOT CALCULATE WHEN STAY IN STEP 3 or 1
      if (self.onboarding === 2) {
        // MAKE FORMAT IN TEXT FOR DATA FROM LOAN SELCTED IN FIRST STEP
        cloneLoanObject.possibility.rentaPagadaMensual = cloneLoanObject.possibility.rentaPagadaMensual.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        cloneLoanObject.possibility.devolucionOriginal = cloneLoanObject.possibility.devolucionOriginal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        cloneLoanObject.possibility.devolucionFinal = cloneLoanObject.possibility.devolucionFinal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        // POPULATE DATA
        cloneLoanObject.possibility.rentaPorPagarMensual = parseFloat(cloneLoanObject.possibility.rentaPorPagarMensual)
        cloneLoanObject.possibility.rentaPorPagarDoble = parseFloat(cloneLoanObject.possibility.rentaPorPagarDoble)
        cloneLoanObject.possibility.currentRent = parseFloat(cloneLoanObject.possibility.currentRent)
        self.possibilityInfo = cloneLoanObject.possibility
      } else if (self.onboarding === 3) {
        self.cronograma = cloneLoanObject.cronograma.source
        self.additionalData = cloneLoanObject.cronograma.data
      }
    })
    this.$root.$on('updateAmountMaxLoan', function (obj) { self.maxAmountLoan = obj.amountMaxLoan })
    this.$root.$on('leavingPage', function (obj) { self.leaving() })
    this.onboarding = this.$store.state.loans.onboarding
    if (this.onboarding === 1) { this.dialogLoans = true }
  },
  mounted () {
    const self = this
    if (!Functionalities.isAvailableSilent(Functionalities.rentas.PRESTAMOS, self.functionsRules, self)) {
      self.$router.push('/inicio')
      return
    }
    // GENERATE UNIQUE RAND NUM
    this.uniqueTrackId = '_' + Math.random().toString(36).substr(2, 15)
    // GENERATE UNIQUE RAND NUM
    if (document.getElementById('container--body-insurance') != null) {
      document.getElementById('container--body-insurance').style.padding = '0px'
      document.getElementById('container--body-insurance').style.height = 'auto'
    }

    this.$gtm.trackEvent({
      event: 'content-view',
      'content-name': '/zona-segura/prestamos/paso/cotizar',
      'content-view-name': 'Préstamo cotizador - paso 1'
    })
  },
  computed: {
    ...mapGetters('user', ['basicInfo', 'names', 'functionsRules'])
  },
  components: {
    LoansFirstStep,
    LoansSecondStep,
    LoansThridStep,
    LoansFinished
  }
}
</script>

<style>
.loans .v-card .v-item-group { width: 100%; }
.loans .steppers button.v-btn {
  border: 1px solid #0855C4;
  color: #0855C4;
  font-family: 'Omnes Medium';
}
/** STEPPERS GLOBAL STYLE */

.loans .v-stepper, .loans .v-stepper .v-stepper__header { box-shadow: none; }
.loans .v-stepper .v-stepper__header .v-divider { border: 1px solid #0855C4; }
.loans .v-stepper .v-stepper__header .v-stepper__step:not(.v-stepper__step--inactive):not(.v-stepper__step--error) span.v-stepper__step__step {
  background-color: #0855C4 !important;
  color: #fff;
  font-weight: bold;
}
.loans .v-stepper .v-stepper__header .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) span.v-stepper__step__step {
  background: #fff;
  border: 2px solid #0855C4;
  color: #0855C4;
  font-weight: bold;
  font-family: 'Omnes Medium';
}
.loans .v-stepper .v-stepper__header .v-stepper__step span.v-stepper__step__step {
  min-width: 30px;
  width: 30px;
  height: 30px;
}
/** MODALS LOANS INFO */
#info-loans .v-card__title {
  text-align: center;
  padding-top: 32px;
}
#info-loans .v-card__title span {
  font-family: 'Omnes Medium' !important;
  display: block;
  width: 100%;
}
#info-loans .v-card__text .layout:first-child,
#info-loans .v-card__text .layout:first-child + .layout { margin-bottom: 0.6em; }
#info-loans .v-card__text .layout .flex p {
  margin-top: 16px;
  padding-left: 1em;
}
#info-loans .v-card__actions { padding: 0; }
.loans #info-loans .v-card__text .layout p.yt-video { text-align: center; }
.loans #info-loans .v-card__text .layout p.yt-video img { width: 36px; }
.loans #info-loans .v-card__text .layout p.yt-video a {
  padding-left: 10px;
  position: relative;
  bottom: 0.7em;
  text-decoration: none;
  font-size: 18px;
}
#info-loans .v-card__actions { display: block; }
.youtube-close-btn {
  border: 1px solid #000;
  position: absolute !important;
  right: 7px;
  top: 0px;
  background-color: #FFF;
}
/* #info-loans .v-card__actions button {
  margin: 0 auto;
  border-radius: 5px;
  background-color: rgb(234,12,144) !important;
  border-color: rgb(234,12,144) !important;
} */
/** MODALS LOANS INFO */
/* Small to large handset ----------- */
@media only screen and (max-width: 600px) {
  .loans .v-stepper__step {
    padding-top: 14px;
  }
  .loans .v-stepper__content {
    padding-top: 10px;
   }
  /* .loans .v-stepper { margin-top: 0; } */
  #info-loans .v-card__text .layout .flex p { margin-top: 0 }
  /* #info-loans .v-card__text .layout .flex img { width: 6rem; } */
  .loans .v-stepper .v-stepper__header .v-divider { margin: 28px -66px 0; }
  #main-stepper.v-stepper--alt-labels .v-stepper__step {
    flex-basis: 160px;
    padding-bottom: 0;
  }
  .loans .v-stepper .v-stepper__items .v-stepper__content:first-of-type + .v-stepper__content {
    padding-right: 15px;
    padding-left: 15px;
  }
}
/* Desktop ----------- */
  @media only screen  and (min-width : 1265px) {
    .loans #main-stepper.v-stepper .v-stepper__header .v-stepper__step { flex-basis: 190px; }
    .loans #main-stepper.v-stepper .v-stepper__header .v-divider { margin: 38px -83px 0; }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Loans/Loans.vue